import { EducationDomainHeader } from './TemplateComponentRegistry.jsx';
import { renderRetailSection } from './RetailTemplateSections.jsx';
import { createTemplateSectionContentRenderer } from './TemplateSectionRegistry.jsx';
import {
  EducationAuthEntrySection,
  EducationAboutPageSection,
  EducationCartPageSection,
  EducationCategoryGridSection,
  EducationContactPageSection,
  EducationCourseDetailPageSection,
  EducationFeatureGridSection,
  EducationFeaturedCoursesSection,
  EducationHeroSection,
  EducationInfoPageSection,
  EducationJoinCommunitySection,
  EducationMissionVisionSection,
  EducationProductsPageSection,
  EducationSummaryPageSection,
} from './sections/education/EducationTemplateSections.jsx';
import {
  EducationExamHomeSectionWithAuth,
  EducationExamPagesSectionWithAuth,
  EducationExamShellSectionWithAuth,
} from './sections/education/EducationExamAuthBridge.jsx';
import {
  FlexOfficeAboutSection,
  FlexOfficeBookingSearchSection,
  FlexOfficeBookingsSection,
  FlexOfficeContactSection,
  FlexOfficeCtaSection,
  FlexOfficeFeaturesSection,
  FlexOfficeHeroSection,
  FlexOfficeInvoiceSection,
  FlexOfficeServiceDetailSection,
  FlexOfficeServicesPageSection,
  FlexOfficeTimelineSection,
  FlexOfficeWorkingHoursSection,
} from './sections/flexOffice/FlexOfficeTemplateSections.jsx';
import {
  ContactBlockSection,
  ContentSection,
  FAQSection,
  FeatureGridSection,
  GenericTemplateSection,
  HeroSection,
  ImageBannerSection,
  TestimonialsSection,
} from './sections/generic/GenericTemplateSections.jsx';
import CustomBuilderSection from './sections/generic/CustomBuilderSection.jsx';
import CanvasSectionRenderer from './sections/canvas/CanvasSectionRenderer.jsx';
import CanvasSectionReader from './sections/canvas/CanvasSectionReader.jsx';
import {
  WaasAuthSection,
  WaasCareerHeroSection,
  WaasContactSection,
  WaasFaqSection,
  WaasHeroSection,
  WaasInstructorSpotlightSection,
  WaasNewsletterFooterSection,
  WaasOpenRolesSection,
  WaasPhilosophySection,
  WaasPricingPlansSection,
  WaasProcessStepsSection,
  WaasScheduleSection,
  WaasServiceDetailSection,
  WaasServicesGridSection,
  WaasStatsStripSection,
  WaasTestimonialsSection,
  WaasTrustedLogosSection,
  WaasWhyAvpsSection,
} from './sections/waas/WaasTemplateSections.jsx';
import WaasImageGallerySection from './sections/waas/WaasImageGalleryCarouselSection.jsx';
import WaasStorySplitSection from './sections/waas/WaasStorySplitSection.jsx';
import WaasPremiumHomeSection from './sections/waas/WaasPremiumHomeSection.jsx';
import WaasAvpsInlinePagesSection from './sections/waas/WaasAvpsInlinePagesSection.jsx';
import {
  EducationWrapperSection,
  ExistingComponentSection,
} from './sections/shared/ExistingComponentSection.jsx';

export const renderTemplateSectionContent = createTemplateSectionContentRenderer({
  renderRetailSection,
  components: {
    CanvasSectionRenderer,
    CanvasSectionReader,
    ContentSection,
    EducationAuthEntrySection,
    EducationAboutPageSection,
    EducationCartPageSection,
    EducationCategoryGridSection,
    EducationContactPageSection,
    EducationCourseDetailPageSection,
    EducationDomainHeader,
    EducationExamHomeSection: EducationExamHomeSectionWithAuth,
    EducationExamPagesSection: EducationExamPagesSectionWithAuth,
    EducationExamShellSection: EducationExamShellSectionWithAuth,
    EducationFeatureGridSection,
    EducationFeaturedCoursesSection,
    EducationHeroSection,
    EducationInfoPageSection,
    EducationJoinCommunitySection,
    EducationMissionVisionSection,
    EducationProductsPageSection,
    EducationSummaryPageSection,
    EducationWrapperSection,
    ExistingComponentSection,
    FAQSection,
    FeatureGridSection,
    FlexOfficeAboutSection,
    FlexOfficeBookingSearchSection,
    FlexOfficeBookingsSection,
    FlexOfficeContactSection,
    FlexOfficeCtaSection,
    FlexOfficeFeaturesSection,
    FlexOfficeHeroSection,
    FlexOfficeInvoiceSection,
    FlexOfficeServiceDetailSection,
    FlexOfficeServicesPageSection,
    FlexOfficeTimelineSection,
    FlexOfficeWorkingHoursSection,
    GenericTemplateSection,
    HeroSection,
    ImageBannerSection,
    TestimonialsSection,
    ContactBlockSection,
    CustomHtmlSection: CustomBuilderSection,
    WaasAboutStorySection: WaasStorySplitSection,
    WaasAvpsInlinePagesSection,
    WaasAuthSection,
    WaasCareerHeroSection,
    WaasContactSection,
    WaasFaqSection,
    WaasHeroSection,
    WaasImageGallerySection,
    WaasInstructorSpotlightSection,
    WaasNewsletterFooterSection,
    WaasOpenRolesSection,
    WaasPhilosophySection,
    WaasPremiumHomeSection,
    WaasPricingPlansSection,
    WaasProcessStepsSection,
    WaasScheduleSection,
    WaasServiceDetailSection,
    WaasServicesGridSection,
    WaasStatsStripSection,
    WaasTestimonialsSection,
    WaasTrustedLogosSection,
    WaasWhyAvpsSection
  }
});
